import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {FiltersDTO} from "../domain/dtos/filters.dto";
import {Filters} from "../domain/entities/filters.entity";
import {AbstractDtoToEntityTransformer} from "./abstract-dto-to-entity.transformer";

@injectable()
@transformer({
    source: `dto`,
    target: Filters
})
export class DtoToKeywordTransformer extends AbstractDtoToEntityTransformer<FiltersDTO, Filters> {

    protected toEntity(dto: FiltersDTO): Promise<Filters> {

        return Promise.resolve(Object.assign(new Filters(), dto));
    }

}